import { useEffect, useState } from 'react';

import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';

export const useOnline = () => {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    setIsOnline(window.navigator.onLine);
    pushEvent({
      eventType: EVENT_TYPE.VIDEO_CHAT_DEBUG,
      eventName: EVENT_NAME.DEBUG__MATCH_LOGGING,
      eventParams: { debug: 'window.navigator.onLine', isOnline: window.navigator.onLine },
    });
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      pushEvent({
        eventType: EVENT_TYPE.VIDEO_CHAT_DEBUG,
        eventName: EVENT_NAME.DEBUG__MATCH_LOGGING,
        eventParams: { debug: 'window.ononline' },
      });
    };
    const handleOffline = () => {
      setIsOnline(false);
      pushEvent({
        eventType: EVENT_TYPE.VIDEO_CHAT_DEBUG,
        eventName: EVENT_NAME.DEBUG__MATCH_LOGGING,
        eventParams: { debug: 'window.onoffline' },
      });
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
};
